var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-speed-dial', {
    attrs: {
      "direction": "left",
      "bottom": "",
      "right": "",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "large": "",
            "color": "accent",
            "dark": "",
            "fab": ""
          },
          model: {
            value: _vm.fab,
            callback: function ($$v) {
              _vm.fab = $$v;
            },
            expression: "fab"
          }
        }, [_vm.fab ? _c('v-icon', [_vm._v("mdi-close")]) : _c('v-icon', [_vm._v("mdi-file-document-edit")])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.fab,
      callback: function ($$v) {
        _vm.fab = $$v;
      },
      expression: "fab"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "disabled": !_vm.allTenantComes,
            "fab": "",
            "dark": _vm.allTenantComes,
            "color": "purple"
          },
          on: {
            "click": function ($event) {
              return _vm.openSendPassword();
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-lock-reset")])], 1)], 1)];
      }
    }])
  }, [_c('span', [_vm._v("Password Link Resend")])]), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "disabled": !_vm.allTenantComes || _vm.isVerified,
            "fab": "",
            "dark": !(!_vm.allTenantComes || _vm.isVerified),
            "color": "blue"
          },
          on: {
            "click": function ($event) {
              return _vm.openSendVerify();
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-email-sync")])], 1)], 1)];
      }
    }])
  }, [_c('span', [_vm._v("Send Email Verify Link")])]), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref3) {
        var on = _ref3.on,
          attrs = _ref3.attrs;
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "disabled": !_vm.allTenantComes || _vm.isVerified,
            "fab": "",
            "dark": !(!_vm.allTenantComes || _vm.isVerified),
            "color": "green"
          },
          on: {
            "click": function ($event) {
              return _vm.openDirectVerify();
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-shield-check")])], 1)], 1)];
      }
    }])
  }, [_c('span', [_vm._v("Verify Account")])]), _vm.hasAccess ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref4) {
        var on = _ref4.on,
          attrs = _ref4.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "fab": "",
            "color": "blue-grey",
            "dark": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openAnonymizeAccount();
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-incognito")])], 1)];
      }
    }], null, false, 2207109786)
  }, [_c('span', [_vm._v("Anonymize Account")])]) : _vm._e(), _vm.hasAccess ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref5) {
        var on = _ref5.on,
          attrs = _ref5.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "fab": "",
            "color": "indigo",
            "dark": ""
          },
          on: {
            "click": function ($event) {
              return _vm.downloadPersonalData();
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-account-arrow-down")])], 1)];
      }
    }], null, false, 4283855229)
  }, [_c('span', [_vm._v("Download Personal Data")])]) : _vm._e(), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref6) {
        var on = _ref6.on,
          attrs = _ref6.attrs;
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [!_vm.isDeleted ? _c('v-btn', {
          attrs: {
            "fab": "",
            "dark": "",
            "color": "red"
          },
          on: {
            "click": function ($event) {
              return _vm.deleteAccount();
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-close")])], 1) : _vm._e(), _vm.isDeleted ? _c('v-btn', {
          attrs: {
            "fab": "",
            "dark": "",
            "color": "success"
          },
          on: {
            "click": function ($event) {
              return _vm.deleteAccount();
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-refresh")])], 1) : _vm._e()], 1)];
      }
    }])
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isDeleted,
      expression: "!isDeleted"
    }]
  }, [_vm._v("Delete Account")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isDeleted,
      expression: "isDeleted"
    }]
  }, [_vm._v("Undelete Account")])])], 1), _c('v-dialog', {
    attrs: {
      "max-width": " 600px"
    },
    model: {
      value: _vm.sendVerify,
      callback: function ($$v) {
        _vm.sendVerify = $$v;
      },
      expression: "sendVerify"
    }
  }, [_c('v-card', [_c('v-flex', {
    staticClass: "mb-12"
  }), _c('base-material-card', {
    attrs: {
      "color": "warning",
      "icon": "mdi-alert-circle-outline"
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "color": "red",
            "outlined": ""
          },
          on: {
            "click": _vm.closeSendVerify
          }
        }, [_vm._v(" Not Now ")]), _c('v-spacer'), _c('v-btn', {
          attrs: {
            "color": "success"
          },
          on: {
            "click": _vm.sendVerifyLink
          }
        }, [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.loading,
            expression: "!loading"
          }]
        }, [_vm._v(" Send Link ")]), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }],
          staticClass: "mng-loader"
        })])];
      },
      proxy: true
    }])
  }, [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_vm._v(" Select tenant for the send verify link")]), _c('v-card-actions', [_c('v-spacer'), _c('div', {
    staticClass: "d-flex flex-column p-4",
    staticStyle: {
      "gap": "2rem",
      "width": "100%",
      "justify-content": "center",
      "padding": "1rem"
    }
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "align-items": "center",
      "gap": "10px"
    }
  }, [_c('SelectTenant', {
    attrs: {
      "tenants": _vm.tenants,
      "allTenants": _vm.allTenants
    },
    on: {
      "onSelect": function ($event) {
        return _vm.selectTenant($event);
      }
    }
  }), _c('v-select', {
    attrs: {
      "items": _vm.language,
      "item-value": "value",
      "item-text": "label",
      "persistent-hint": "",
      "label": "Select language"
    },
    model: {
      value: _vm.selectedLanguage,
      callback: function ($$v) {
        _vm.selectedLanguage = $$v;
      },
      expression: "selectedLanguage"
    }
  })], 1)]), _c('v-spacer')], 1)], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "max-width": " 500px"
    },
    model: {
      value: _vm.directVerify,
      callback: function ($$v) {
        _vm.directVerify = $$v;
      },
      expression: "directVerify"
    }
  }, [_c('v-card', [_c('v-flex', {
    staticClass: "mb-12"
  }), _c('base-material-card', {
    attrs: {
      "color": "warning",
      "icon": "mdi-alert-circle-outline"
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "color": "red",
            "outlined": ""
          },
          on: {
            "click": _vm.closeDirectVerify
          }
        }, [_vm._v(" Not Now ")]), _c('v-spacer'), _c('v-btn', {
          attrs: {
            "color": "success"
          },
          on: {
            "click": _vm.sendDirectVerify
          }
        }, [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.loading,
            expression: "!loading"
          }]
        }, [_vm._v("Verify ")]), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }],
          staticClass: "mng-loader"
        })])];
      },
      proxy: true
    }])
  }, [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_vm._v(" Do you want to verify this account? ")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "max-width": " 700px"
    },
    model: {
      value: _vm.anonymizeAccountDialog,
      callback: function ($$v) {
        _vm.anonymizeAccountDialog = $$v;
      },
      expression: "anonymizeAccountDialog"
    }
  }, [_c('v-card', [_c('v-flex', {
    staticClass: "mb-12"
  }), _c('base-material-card', {
    attrs: {
      "color": "warning",
      "icon": "mdi-alert-circle-outline"
    },
    scopedSlots: _vm._u([{
      key: "after-heading",
      fn: function () {
        return [_c('div', {
          staticClass: "ml-auto body-3"
        }, [_vm._v(" Anonymize Account "), _c('h3', [_vm._v("Are you sure that you want to anonymize this account?")])])];
      },
      proxy: true
    }, {
      key: "actions",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "color": "red",
            "outlined": "",
            "large": ""
          },
          on: {
            "click": function ($event) {
              _vm.anonymizeAccountDialog = false;
            }
          }
        }, [_vm._v("Cancel")]), _c('v-spacer'), _c('v-btn', {
          attrs: {
            "color": "success",
            "large": ""
          },
          on: {
            "click": _vm.anonymizeAccount
          }
        }, [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.loading,
            expression: "!loading"
          }]
        }, [_vm._v("Confirm")]), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }],
          staticClass: "mng-loader"
        })])];
      },
      proxy: true
    }])
  }, [_c('v-divider', {
    staticClass: "mt-2"
  }), _c('v-card-actions', [_c('v-spacer'), _c('div', {
    staticClass: "d-flex flex-column p-4",
    staticStyle: {
      "width": "100%",
      "justify-content": "center",
      "padding": "1rem"
    }
  }, [_c('p', {
    staticClass: "subtitle-1 font-weight-bold secondary--text mb-0"
  }, [_vm._v(" The orders of this account will also be anonymized. If you don’t want to anonymize the orders, please tick the box below. ")]), _c('v-checkbox', {
    attrs: {
      "label": "Do not anonymize orders"
    },
    model: {
      value: _vm.doNotAnonymizeOrders,
      callback: function ($$v) {
        _vm.doNotAnonymizeOrders = $$v;
      },
      expression: "doNotAnonymizeOrders"
    }
  })], 1), _c('v-spacer')], 1)], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "max-width": " 600px"
    },
    model: {
      value: _vm.sendPassword,
      callback: function ($$v) {
        _vm.sendPassword = $$v;
      },
      expression: "sendPassword"
    }
  }, [_c('v-card', [_c('v-flex', {
    staticClass: "mb-12"
  }), _c('base-material-card', {
    attrs: {
      "color": "warning",
      "icon": "mdi-alert-circle-outline"
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "color": "red",
            "outlined": "",
            "x-large": ""
          },
          on: {
            "click": function ($event) {
              _vm.sendPassword = false;
            }
          }
        }, [_vm._v("Not Now ")]), _c('v-spacer'), _c('v-btn', {
          attrs: {
            "color": "success",
            "x-large": ""
          },
          on: {
            "click": _vm.sendResetPassword
          }
        }, [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.loading,
            expression: "!loading"
          }]
        }, [_vm._v("Send Password Link ")]), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }],
          staticClass: "mng-loader"
        })])];
      },
      proxy: true
    }])
  }, [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_vm._v(" Select tenant for the send reset password link")]), _c('v-divider', {
    staticClass: "mt-2"
  }), _c('v-card-actions', [_c('v-spacer'), _c('div', {
    staticClass: "d-flex flex-column p-4",
    staticStyle: {
      "gap": "2rem",
      "width": "100%",
      "justify-content": "center",
      "padding": "1rem"
    }
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "align-items": "center",
      "gap": "10px"
    }
  }, [_c('SelectTenant', {
    attrs: {
      "tenants": _vm.tenants,
      "allTenants": _vm.allTenants
    },
    on: {
      "onSelect": function ($event) {
        return _vm.selectTenant($event);
      }
    }
  }), _c('v-select', {
    attrs: {
      "items": _vm.language,
      "item-value": "value",
      "item-text": "label",
      "persistent-hint": "",
      "label": "Select language"
    },
    model: {
      value: _vm.selectedLanguage,
      callback: function ($$v) {
        _vm.selectedLanguage = $$v;
      },
      expression: "selectedLanguage"
    }
  })], 1)]), _c('v-spacer')], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }